import React from 'react';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import { ChevronLeftRounded, AccountCircle, Mic, ChevronRightRounded } from '@mui/icons-material';
import { DateTime } from 'luxon';
import { styles } from '../styles';
import theme from 'theme';

type Props = {
    formattedContent: string;
};

const SmsPreview = ({ formattedContent }: Props) => (
    <Stack
        height="auto"
        justifySelf="center"
        sx={{ width: '100%', maxWidth: '320px', maxHeight: 'calc(100vh - 250px)' }}
    >
        <Stack sx={styles.previewContainer}>
            {/* Header */}
            <Stack direction="row" alignItems="center" sx={styles.previewHeader}>
                <ChevronLeftRounded fontSize="large" htmlColor={`${theme.palette.grey[400]}`} />
                <Box flex={1} ml={-5} display="flex" justifyContent="center">
                    <Stack alignItems="center">
                        <AccountCircle fontSize="large" htmlColor={`${theme.palette.grey[400]}`} />
                        <Stack direction="row" alignItems="center">
                            <Typography variant="body2" color="text.primary">
                                +1 (999) 999-9999
                            </Typography>
                            <ChevronRightRounded fontSize="small" htmlColor={`${theme.palette.grey[400]}`} />
                        </Stack>
                    </Stack>
                </Box>
            </Stack>

            {/* Message Area */}
            <Stack sx={styles.messageArea}>
                <Typography
                    variant="overline"
                    sx={{
                        color: '#3C3C4399',
                        textAlign: 'center',
                        mb: 1,
                    }}
                >
                    Text Message • SMS
                    <br />
                    {DateTime.now().toFormat("ccc, MMM d 'at' h:mm a")}
                </Typography>

                <Box sx={{ display: 'flex', mb: 2 }}>
                    <Box sx={styles.messageBubble}>
                        <Typography variant="body2" sx={styles.messageText}>
                            {formattedContent}
                        </Typography>
                    </Box>
                </Box>
            </Stack>

            {/* Input Area */}
            <Stack direction="row" sx={styles.inputArea}>
                <Stack direction="row" sx={styles.inputField}>
                    <Typography variant="body2" fontSize="14px" sx={{ color: `${theme.palette.grey[400]}` }}>
                        Text Message • SMS
                    </Typography>
                    <IconButton sx={{ color: `${theme.palette.grey[400]}` }}>
                        <Mic />
                    </IconButton>
                </Stack>
            </Stack>
        </Stack>
    </Stack>
);

export default React.memo(SmsPreview);
